import { useLanguage } from "./LanguageContext";

export default function useTranslation() {
    const { t, getRaw, language, setLanguage, supportedLanguages } = useLanguage();

    return {
        t,
        getRaw,
        language,
        setLanguage,
        supportedLanguages,
    };
}